export default "../310cc78225529466c911bc0589c52fac.png";